module.exports = "\n<app-full-layout></app-full-layout>"